import "./section-anna-art.css";
import Swiper, {
  Controller,
  EffectFade,
  EffectCreative,
  Scrollbar,
} from "swiper";

class AnnaArts extends HTMLElement {
  constructor() {
    super();

    let galleryBg = this.querySelector("#gallery-bg");
    let thumbs = this.querySelector("#floater");
    let width = galleryBg.offsetWidth;
    thumbs.style.width = width + "px";

    const artSwiper = new Swiper(".artgallerySwiper", {
      modules: [Controller, EffectFade],
      spaceBetween: 0,
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      watchSlidesProgress: true,
      allowTouchMove: false,
      thumbs: {
        swiper: artThumbSwiper,
      },
    });

    const artDescrSwiper = new Swiper(".artdescrSwiper", {
      modules: [EffectCreative],
      spaceBetween: 0,
      slidesPerView: 1,
      effect: "creative",
      creativeEffect: {
        perspective: true,
        prev: {
          // will set `translateZ(-400px)` on previous slides
          translate: [0, 0, -400],
        },
        next: {
          // will set `translateX(100%)` on next slides
          translate: [0, 0, -400],
        },
      },
      allowTouchMove: false,
      slideActiveClass: "opacity-1 pointer-events-auto",
      watchSlidesProgress: true,
    });

    var artThumbSwiper = new Swiper(".artthumbSwiper", {
      modules: [Controller, Scrollbar],
      slidesPerView: "auto",
      centeredSlides: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      spaceBetween: 17,
      slideActiveClass: "opacity-20",
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });

    artThumbSwiper.controller.control = artSwiper;
    artSwiper.controller.control = artDescrSwiper;
  }
}

customElements.define("section-anna-art", AnnaArts);
